import React from 'react';
import PropTypes from 'prop-types';

const CardError = ({ className }, context) => (
        <div className={`hotel-alternative mx-auto ${className}`}>
          <header className="py-4">
            <h1>{context.t('No Availability for this search')}</h1>
            <h2>
              {context.t('The hotel has no rooms available for the selected dates. If you wish, you can try other dates, search again for another hotel or destination, or contact our call center.')}
            </h2>
          </header>
        </div>
);

CardError.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CardError;
